module.exports = __webpack_public_path__ + "static/media/ic_erazer_disabled.29505b73.svg";